import { BaseView } from "@pepsico/layout";

import { usePermissions } from "components/UserProvider";
import { appPages, pageNavOrder } from "defs";

const AppBaseView: React.FC = () => {
  const permissions = usePermissions();

  return (
    <BaseView
      appPages={appPages}
      pageNavOrder={pageNavOrder}
      permissions={permissions}
    />
  );
};

export default AppBaseView;
